import React from "react";
import { EditMemberTeamContainer } from "../../containers/Team/Member/EditMemberTeamContainer";

export const MemberEditView = () => {
    return (<EditMemberTeamContainer />);
}